module.exports = __webpack_public_path__ + "static/media/Kolyachenko.c4437e67.png";